// ============================================================================
// FILE: src/modules/invoice/components/InvoicePreview.jsx
// CREATED: 2025-12-03
// PURPOSE: Display preview of uploaded invoice image.
// COMMENTS:
// - Used in InvoiceUploadPage
// - Shows selected image before sending to backend
// ============================================================================

import React from "react";

const InvoicePreview = ({ imageUrl }) => {
  if (!imageUrl) return null;

  return (
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Invoice Preview</h3>
      <img
        src={imageUrl}
        alt="Invoice Preview"
        className="rounded-lg border shadow max-h-96 object-contain"
      />
    </div>
  );
};

export default InvoicePreview;
